// extracted by mini-css-extract-plugin
export default {"delete_btn":"DeleteFAQ_delete_btn__9Kya8","spinner":"DeleteFAQ_spinner__B4cc9","spinner_deleting":"DeleteFAQ_spinner_deleting__uO4Pq"};